import React from "react";
import { ViewMoreAds } from "../../../pages";

const ViewMoreAdsContainer = ({ item, closeModal }) => {
  return <ViewMoreAds item={item} closeModal={closeModal} />;
};

export default ViewMoreAdsContainer;
